import React from "react";
import Styles from "../ClosePopup/ClosePopup.module.css";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { ReactComponent as ErrorIcon } from "../../../../assets/images/IconError.svg";

const ClosePopup = ({ open, handleClose, onConfirm, loading = false }) => {
  return (
    <Modal open={open} onClose={!loading ? handleClose : undefined}>
      <div className={Styles.createEditModalCont}>
        <div className={`headingText ${Styles.withdrawText}`}>
          <span>Close Banking Transaction</span>
          <span
            className={Styles.closeIcon}
            onClick={!loading ? handleClose : undefined}
          >
            <Close style={{ fontSize: 20 }} />
          </span>
        </div>

        <div className={Styles.headerSection}>
          <ErrorIcon style={{ width: "36px", height: "36px" }} />

          <span className={Styles.primaryText}>
            Are you sure you want to{" "}
            <span style={{ color: "var(--warning-shade-text)" }}>close</span>{" "}
            this banking transaction?
          </span>

          <span className={Styles.helperText}>
            Once closed, this transaction cannot be edited or modified.
          </span>
        </div>

        <div className={Styles.buttonSection}>
          <div
            onClick={!loading ? handleClose : undefined}
            className={`${Styles.btn} ${Styles.cancelBtn}`}
          >
            Cancel
          </div>
          <div
            onClick={!loading ? onConfirm : undefined}
            className={`${Styles.btn} ${Styles.confirmBtn} ${
              loading ? Styles.loading : ""
            }`}
          >
            {loading ? "Processing..." : "Close Transaction"}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ClosePopup;
